import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { COLORS } from "../../constant";

const useStyles = CreateResponsiveStyle(
  {
    mainContainer:{backgroundColor:'#fff',borderRadius: 12,marginLeft:20,marginTop:20,paddingBottom:30},
    contentWrapper: {
      display: "flex",
      marginLeft: 30,
      marginTop: 10,
      paddingTop: 8.3,
      marginRight: 63,
    },
    inActivePlanCard: {
      marginTop: 12,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 10,
      borderWidth: 0.5,
      // borderColor: COLORS.boderColor,
      borderColor:'#58a792',
      paddingVertical: 20,
      minWidth: 300,
      minHeight: 200,
    },
    // activePlanCard: {
    //   borderRadius: 10,
    //   borderWidth: 0,
    //   // backgroundColor: COLORS.cardBg,
    //   backgroundColor:'#58a792',
    //   marginTop: 10,
    //   minWidth: 300,
    //   minHeight: 200,
    //   shadowRadius: 4,
    //   shadowOffset: { width: 0.1, height: 0.1},
    // },
    // activePlanCardBg: {
    //   // backgroundColor: COLORS.cardHeaderBg,
    //   backgroundColor:'#287a5b',
    //   borderRadius: 10,
    // },
    activePlanCard: {
      borderRadius: 10,
      borderWidth: 1,
      backgroundColor: COLORS.cardBg,
      marginTop: 10,
      minWidth: 300,
      minHeight: 200,
    },
    activePlanCardBg: {
      backgroundColor: COLORS.cardHeaderBg,
      borderRadius: 10,
    },
    statusBtn: {
      color: COLORS.white,
      backgroundColor: COLORS.lightYellow,
      // textTransform: "uppercase",
      paddingHorizontal: 22,
      padding: 3,
    },
    
    footer: {
      flexDirection: "row",
      alignSelf: "flex-end",
      width: 220,
      height: 44,
      marginTop: 82,
    },
    custInfoWrapper: {
      flex: 1,
      gap: 15,
      marginTop: 32.6,
    },
    infoWrapper: {
      flexDirection: "row",
      gap: 70,
      position: "relative",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    overlayContentStyle: {
      width: "80%",
      height: 400,
      backgroundColor: "white",
      borderRadius: 15,
      alignSelf:"center",
      justifyContent:"center",
      marginVertical:10
    },
    pdfViewStyle: {
      height: 330,
      width: "100%",
    },
    cir86: {
      backgroundColor: COLORS.lightRed,
      width: 86,
      height: 86,
      borderRadius: "50%",
      alignItems: "center",
      justifyContent: "center",
    },
    responsiveWidget: {
      flexDirection: "row",
      marginTop: 14,
      justifyContent: "space-between",
      width:"100%"
    },
    responsiveImgWidget: {
      flexDirection: "row",
      marginTop: 14,
      width:'75%',
      justifyContent:'space-between',
    },
    cancelBtn: {
      marginVertical: 26,
      width: "90%",
      borderColor: COLORS.white,
      borderWidth: 1,
    },
    detailTxt: {
      color: COLORS.white,
      opacity: 0.7,
      marginBottom:5
    },
    tripInsRefTextWidget:{
      alignItems:'center',
      paddingTop:40,
      marginBottom:5
    },
    leftPanel:{width:'66%'},
    iconCertificateStyle:{width:'100%',minHeight:80,backgroundColor:"#ffd3d4", borderRadius:12,alignItems:'center',paddingTop:20},
    iconTransactionStyle:{width:'100%',minHeight:80,backgroundColor:'#d5dbff',borderRadius:12,alignItems:'center',paddingTop:20},
    iconHistoryStyle:{ width:'100%',minHeight:80,backgroundColor:'#feecbd',marginRight:12,borderRadius:12,alignItems:'center',paddingTop:20 },
    iconFaqStyle:{ width:'100%',minHeight:60,backgroundColor:'#e2d8ff',marginRight:12,borderRadius:12,alignItems:'center',paddingTop:12 },
    responsiveImgWidgetMobile:{flexDirection:'row', justifyContent:'center',marginLeft:50, display:'none'},
    activePlanCardWrapper:{marginLeft:50},
    autoRenewalActiveCard:{width:'100%',minHeight:100,borderRadius:10,padding:14,flexDirection:'row',justifyContent:'space-between',borderWidth:1,borderColor:COLORS.boderColor},
    autoRenewalDisableCard:{width:'100%', minHeight:80,borderRadius:10,padding:14,flexDirection:'row',justifyContent:'space-between',borderWidth:1,borderColor:COLORS.boderColor},
   autoRenewalDisableCardText:{width:'50%', },
   claimInsPicStyle:{width:'25%',marginLeft:-20},
   optInsPicStyle:{width:'30%',},
   certInsPicStyle:{width:'30%',},
   titleWrapper:{ flexDirection: "row",
   alignItems: "center",
   justifyContent:'center',
   zIndex: 5,
   paddingTop: 10,
   width: "100%",
   height: 70,
   borderRadius: 12,
   backgroundColor: "#ffffff",
   shadowColor: "rgba(0, 0, 0, 0.06)",
   shadowOffset: {
     width: 0,
     height: 3,
   },
   shadowRadius: 6,
   shadowOpacity: 1,}
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      tripInsRefTextWidget:{
        marginBottom:15
      },
      responsiveWidget:{
        flexDirection:'column-reverse',
        width:'110%'
      },
      activePlanCard:{width:'100%',minWidth:500,alignSelf:'flex-end'},
      responsiveImgWidget:{width:'100%'},
      claimInsPicStyle:{ width:'30%',},
      optInsPicStyle:{width:'50%',},
      certInsPicStyle:{width:'55%',}
    },
    [DEVICE_SIZES.SM]: {
      mainContainer:{backgroundColor:'#fff',borderRadius: 12,marginHorizontal:10,marginTop:20,paddingBottom:30},
      tripInsRefTextWidget:{
        marginBottom:15
      },
      activePlanCard: {
        minWidth: 280,
      },
      overlayContentStyle: {
        width: "90%",
        height: 600,
      },
      pdfViewStyle: {
        height: 530,
        width: "100%",
      },
      tripInsRefTextWidget:{
        marginBottom:15
      },
      responsiveImgWidgetMobile:{display:'flex'},
      activePlanCardWrapper:{marginLeft:60},
      autoRenewalActiveCard:{flexDirection:'column',alignSelf:'flex-end', marginRight:5,idth:'100%',},
      autoRenewalDisableCardText:{width:'90%'},
      autoRenewalDisableCard:{flexDirection:'column',alignSelf:'flex-end', marginRight:5,idth:'100%',},
    },
    [DEVICE_SIZES.XS]: {
      mainContainer:{backgroundColor:'#fff',borderRadius: 12,marginHorizontal:10,marginTop:20,paddingBottom:30,marginLeft:15},
      contentWrapper: {
        paddingLeft: 0,
        marginLeft: 22,
        flexDirection: "column",
        justifyContent: "center",
      },
      activePlanCardWrapper:{marginLeft:40},
      autoRenewalActiveCard:{flexDirection:'column',alignSelf:'flex-end', marginRight:5,idth:'100%',},
      autoRenewalDisableCardText:{width:'90%'},
      autoRenewalDisableCardText:{flexDirection:'column',alignSelf:'flex-end', marginRight:5,idth:'100%',},
      infoWrapper: {
        flexDirection: "column",
        gap: 10,
      },
      custInfoWrapper: {
        marginTop: 30,
      },
      footer: {
        alignSelf: "center",
        marginTop: 30,
      },
      responsiveWidget: {
        justifyContent: "center",
        flexDirection: "column-reverse",
        alignItems: "center",
      },
      responsiveImgWidget: {
        width: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        display:'none'
      },
      responsiveImgWidgetMobile:{display:'flex',left:10},
      leftPanel:{width:'100%'},
      responsiveGap: {
        marginTop: 40,
      },
      inActivePlanCard: {
        minWidth: 280,
        marginBottom: 20,
        marginTop: 10,
        marginLeft: 0,
      },
      activePlanCard: {
        minWidth: 280,
        marginBottom: 20,
        marginTop: 10,
        marginLeft: 0,
      },
      overlayContentStyle: {
        width: "90%",
        height: 600,
      },
      pdfViewStyle: {
        height: 530,
        width: "100%",
      },
      tripInsRefTextWidget:{
        marginBottom:15,
        width:320,
        marginLeft:-30
      }
    },
  }
);

export default useStyles
